import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { decode } from 'html-entities';
// import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export class Cal extends Component  {
  state = { isLoaded: false, events: [] }

  componentDidMount() {
    this.props.events.forEach((e) => {
      let oneEvent = {
        title: e.title,
        start: e.start,
        end: e.end,
        url: '/event?eventid='+e.id
      }

      this.state.events.push(oneEvent);
    });

    this.setState({ isLoaded: true });
  }

  render() {
    const { events, isLoaded } = this.state;
    // console.dir(events);
    // console.log(isLoaded);

    return (
      <>
        <section className="eventCalCont">

          {isLoaded && (
            <FullCalendar plugins={[ dayGridPlugin, interactionPlugin ]} initialView="dayGridMonth"
              events={ events }
            />
          )}

        </section>
      </>
    );
  }
}

export default Cal;